<template lang="pug">
  .div
    .columns
      .column.is-2.is-offset-4.has-text-centered
        div(v-show="verHistoria")
          router-link.a.button.is-light(v-if="pm101.flujo + pm103.flujo > 0" to="/ExpedienteDescarga") 
            | Expediente de Descarga Actual &nbsp
            span.icon
              i.fas.fa-link
          a.button.is-text(v-else disabled)
            | Expediente de Descarga Actual &nbsp
            span.icon
              i.fas.fa-link
      .column.is-2.has-text-centered
        div(v-show="verHistoria")
          router-link.a.button.is-light(to="/ConsultaHistorica") 
            | Consulta Histórica &nbsp
            span.icon
              i.fas.fa-link

    .card
      .card-content 
        .columns
              .column.is-2
                label.label Fecha de reporte:
                  .field
                    .control
                      flat-pickr(
                        v-model='fechaReporte'
                        :config="config"
                        class="input"
                      )
              .column.is-2
                label.label Patín
                  .field
                    .control
                      .select.is-dark
                        select(v-model="patinSelect")
                          option(v-for="patin in patines" :key="patin.id" :value="patin.id" v-text="patin.nombre")        
              .column.is-1.button-bottom
                a.button.is-black.is-rounded.is-small.mt-30.is-top(@click="descargarReporte")
                    i.fas.fa-print 
                | &nbsp
    .columns.mt-30
      .column.is-6-desktop.is-6-tablet
        .columns
          .card
            .card-image
              br
              figure.image(v-if="parseFloat(pm101.flujo) > 0")
                img(src="../../assets/PatinTPA.png" alt='')
              figure.image(v-else)
                img(src="../../assets/PatinTPADisabled.png" alt='')
              .card-content.is-overlay.is-clipped
                span.tag.is-dark
                  | Patín pm101
            footer.card-footer
              a.card-footer-item
                .column.is-3-desktop.is-6-tablet
                  p.has-text-grey-dark 
                    span Presión:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.presion }}&nbsp
                    small kg/cm²
                  p.has-text-grey-dark 
                    span Temperatura:
                    b.has-text-primary.valorItem &nbsp{{ pm101.temperatura }}&nbsp
                    small °C
                .column.is-3-desktop.is-6-tablet
                  p.has-text-grey-dark
                    span Densidad:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.densidad }}&nbsp
                    small kg/cm³
                  p.has-text-grey-dark
                    span Densidad Cor.:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.densidad20 }}&nbsp
                    small kg/cm³
                .column.is-3-desktop.is-6-tablet
                  p.has-text-grey-dark
                    span Flujo:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.flujo }}&nbsp
                    small Ton/hr
                  p.has-text-grey-dark
                    span fqi grossiv:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.grossiv }}&nbsp
                    small m³
                .column.is-3-desktop.is-6-tablet
                  p.has-text-grey-dark
                    span fql netgsv:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.netgsv }}&nbsp
                    small m³
                  p.has-text-grey-dark
                    span fqi mass:
                    b.has-text-primary.valorItem.has-text-right &nbsp{{ pm101.fqi }}&nbsp
                    small Ton
            span.valorItem#presion101 
              | PI-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.presion).toFixed(2) }} &nbsp
              small kg/cm²
            span.valorItem#temperatura101 
              | TI-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.temperatura).toFixed(2) }} &nbsp
              small °C
            span.valorItem#flujo101 
              | FI-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.flujo).toFixed(2) }} &nbsp
              small Ton/hr
            span.valorItem#densidad101 
              | DI-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.densidad).toFixed(1) }} &nbsp
              small kg/cm³
            span.valorItem#densidad20101 
              | DI-101_20: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.densidad20).toFixed(1) }} &nbsp
              small kg/cm³
            span.valorItem#fqiG101 
              | FQIGross-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.grossiv).toFixed(3) }} &nbsp
              small m³
            span.valorItem#fqiNet101 
              | FQInet-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.netgsv).toFixed(3) }} &nbsp
              small m³
            span.valorItem#fqiMass101 
              | FQI-101: 
              b.has-text-dark.has-text-primary {{ parseFloat(pm101.fqi).toFixed(3) }} &nbsp
              small Ton
      .column.is-6-desktop.is-6-tablet
        .card
          .card-image
            br
            figure.image(v-if="parseFloat(this.pm103.flujo) > 0")
              img(src="../../assets/PatinTPA.png" alt='')
            figure.image(v-else)
              img(src="../../assets/PatinTPADisabled.png" alt='')
            .card-content.is-overlay.is-clipped
              span.tag.is-dark
                | Patín pm103
          footer.card-footer
            a.card-footer-item
              .column.is-3-desktop.is-6-tablet
                p.has-text-grey-dark 
                  span Presión:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.presion }}&nbsp
                  small kg/cm²
                p.has-text-grey-dark 
                  span Temperatura:
                  b.has-text-primary.valorItem &nbsp{{ pm103.temperatura }}&nbsp
                  small °C
              .column.is-3-desktop.is-6-tablet
                p.has-text-grey-dark
                  span Densidad:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.densidad }}&nbsp
                  small kg/cm³
                p.has-text-grey-dark
                  span Densidad Cor.:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.densidad20 }}&nbsp
                  small kg/cm³
              .column.is-3-desktop.is-6-tablet
                p.has-text-grey-dark
                  span Flujo:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.flujo }}&nbsp
                  small Ton/hr
                p.has-text-grey-dark
                  span fqi grossiv:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.grossiv }}&nbsp
                  small m³
              .column.is-3-desktop.is-6-tablet
                p.has-text-grey-dark
                  span fql netgsv:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.netgsv }}&nbsp
                  small m³
                p.has-text-grey-dark
                  span fqi mass:
                  b.has-text-primary.valorItem.has-text-right &nbsp{{ pm103.fqi }}&nbsp
                  small Ton
          span.valorItem#presion103 
            | PI-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.presion).toFixed(2) }} &nbsp
            small kg/cm²
          span.valorItem#temperatura103 
            | TI-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.temperatura).toFixed(2) }} &nbsp
            small °C
          span.valorItem#flujo103 
            | FI-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.flujo).toFixed(2) }} &nbsp
            small Ton/hr
          span.valorItem#densidad103 
            | DI-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.densidad).toFixed(1) }} &nbsp
            small kg/cm³
          span.valorItem#densidad20103 
            | DI-103_20: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.densidad20).toFixed(1) }} &nbsp
            small kg/cm³
          span.valorItem#fqiG103 
            | FQIGross-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.grossiv).toFixed(3) }} &nbsp
            small m³
          span.valorItem#fqiNet103 
            | FQInet-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.netgsv).toFixed(3) }} &nbsp
            small m³
          span.valorItem#fqiMass103 
            | FQI-103: 
            b.has-text-dark.has-text-primary {{ parseFloat(pm103.fqi).toFixed(3) }} &nbsp
            small Ton
</template>


<script>
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import sca_tuxpanServices from '@/services/sca/tpa.js'
  export default {
    name: 'Muelle_TPA',
    components: { flatPickr},
    props: {
      activo: {
        type: Boolean,
        default: false
      },
      verHistoria: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        refresh: null,
        pm101: {},
        pm102: {},
        pm103: {},
        patines: [
          { id: 101, nombre: 'Patin 101'},
          { id: 103, nombre: 'Patin 103'}
        ],
        patinSelect: {},
        conflujo: false,
        activarData: this.activo,
        fechaReporte: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
      }
    },
    watch: {
      activo (active) {
        console.log(active)
        this.activarData = active 
        if (active) {
          this.iniciarComponente()
        } else {
          clearInterval(this.refresh)
        }
      }
  },
    methods: {
      descargarReporte(){
        const currentUrl = window.location.hostname
          let link = ''
          if (currentUrl === '10.122.40.189') {
            link = `http://${currentUrl}/servidores/reportes/monitoreo/patinTpa.php?fecha=${this.fechaReporte}&patin=${this.patinSelect}`
          }
          else {
            link = `https://${currentUrl}/servidores/reportes/monitoreo/patinTpa.php?fecha=${this.fechaReporte}&patin=${this.patinSelect}`
          }
        open(link, '_blank')
      },
      iniciarComponente () {
        this.refresh = setInterval(() => {
          if (this.activarData) {
            this.obtenerDatosPatinTPA()
          } else {
            console.log('No hacer nada')
            clearInterval(this.refresh)
          }
        }, 5000)
      },
      obtenerDatosPatinTPA () {
        sca_tuxpanServices.getPatinTPA()
        .then(data => {
          this.pm101 = data[0]
          this.pm102 = data[1]
          this.pm103 = data[2]
        })
      },

      

      goDownloadFile(flujo) {
        return flujo > 0 ? this.eda.ruta : '#'
      },
    },
    created () {
      this.obtenerDatosPatinTPA()
      this.iniciarComponente()
    },
    beforeDestroy() {
      console.log('Antes de destruirse Muelle TPA')
      clearInterval(this.refresh)
      console.log(this.refresh)
    }      
  }
</script>

<style lang="scss" scoped>
.mt-30{
    margin-top: 30px !important;
  }
  @media (min-width:320px) and (max-width: 480px) {
    /* smartphones, iPhone, portrait 480x320 phones */ 
    .valorItem {
      font-weight: 600;
      font-size: 12px
    }

    #fqiG101 {
      display: none;
    }

    #fqiNet101 {
      display: none;
    }

    #fqiMass101 {
      display: none;
    }

    #densidad101 {
      position: absolute;
      top: 70px; 
      left: 60px;
      font-size: 10px
    }

    #densidad20101 {
      position: absolute;
      bottom: 70px;
      left: 50px;
      font-size: 10px
    }

    #flujo101 {
      position: absolute;
      top: 60px;
      right: 87px;
      font-size: 10px
    }

    #presion101 {
      position: absolute;
      top: 100px;
      right: 55px;
      font-size: 10px
    }

    #temperatura101 {
      position: absolute;
      top: 70px;
      right: 10px;
      font-size: 10px
    }

    #fqiG103 {
      display: none;
    }

    #fqiNet103 {
      display: none;
    }

    #fqiMass103 {
      display: none;
    }

    #densidad103 {
      position: absolute;
      top: 70px; 
      left: 60px;
      font-size: 10px
    }

    #densidad20103 {
      position: absolute;
      bottom: 70px;
      left: 50px;
      font-size: 10px
    }

    #flujo103 {
      position: absolute;
      top: 60px;
      right: 87px;
      font-size: 10px
    }

    #presion103 {
      position: absolute;
      top: 100px;
      right: 55px;
      font-size: 10px
    }

    #temperatura103 {
      position: absolute;
      top: 70px;
      right: 10px;
      font-size: 10px
    }

  }
  
  @media (min-width:320px) and (orientation: landscape)  { 
    /* smartphones, iPhone, portrait 480x320 phones */ 
    .valorItem {
      font-weight: 500;
      // // color: #54545c !important;
      // color: red !important;
    }
  }

  @media screen and (max-width: 600px) {
  
    .valorItem {
      font-weight: 500;
      // color: #54545c !important;
    }
  }

  @media (min-width:481px) {
    /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
    .valorItem {
      font-weight: 500;
      // // color: #54545c !important;
      // color: red !important;
    }
  }

  @media (min-width:641px)  { 
    /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ 
    #densidad101 {
      position: absolute;
      top: 130px; 
      left: 180px;
    }

    #densidad20101 {
      position: absolute;
      bottom: 110px;
      left: 160px;
    }

    #flujo101 {
      position: absolute;
      top: 130px;
      right: 235px;
    }

    #presion101 {
      position: absolute;
      top: 195px;
      right: 125px;
    }

    #temperatura101 {
      position: absolute;
      top: 130px;
      right: 45px;
    }

    #fqiG101 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet101 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass101 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    #densidad103 {
      position: absolute;
      top: 130px; 
      left: 180px;
    }

    #densidad20103 {
      position: absolute;
      bottom: 110px;
      left: 160px;
    }

    #flujo103 {
      position: absolute;
      top: 130px;
      right: 235px;
    }

    #presion103 {
      position: absolute;
      top: 195px;
      right: 125px;
    }

    #temperatura103 {
      position: absolute;
      top: 130px;
      right: 45px;
    }

    #fqiG103 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet103 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass103 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    .valorItem {
      font-weight: 500;
      // color: #54545c !important;
      // color: red !important;
    }
  
  }

  @media (min-width:961px)  { 
    /* tablet, landscape iPad, lo-res laptops ands desktops */ 
    #densidad101 {
      position: absolute;
      top: 120px; 
      left: 170px;
    }

    #densidad20101 {
      position: absolute;
      bottom: 100px;
      left: 150px;
    }

    #flujo101 {
      position: absolute;
      top: 120px;
      right: 205px;
    }

    #presion101 {
      position: absolute;
      top: 180px;
      right: 125px;
    }

    #temperatura101 {
      position: absolute;
      top: 120px;
      right: 50px;
    }

    #fqiG101 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet101 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass101 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    #densidad103 {
      position: absolute;
      top: 120px; 
      left: 170px;
    }

    #densidad20103 {
      position: absolute;
      bottom: 100px;
      left: 150px;
    }

    #flujo103 {
      position: absolute;
      top: 120px;
      right: 205px;
    }

    #presion103 {
      position: absolute;
      top: 180px;
      right: 125px;
    }

    #temperatura103 {
      position: absolute;
      top: 120px;
      right: 50px;
    }

    #fqiG103 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet103 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass103 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    .valorItem {
      font-weight: 400;
      // color: #54545c !important;
      // color: red !important;
      font-size: 13px;
    }
  
  }

  @media (min-width:1025px) { 
    /* big landscape tablets, laptops, and desktops */ 
    #densidad101 {
      position: absolute;
      top: 160px; 
      left: 230px;
    }

    #densidad20101 {
      position: absolute;
      top: 340px;
      left: 210px;
    }

    #flujo101 {
      position: absolute;
      top: 160px;
      right: 290px;
    }

    #presion101 {
      position: absolute;
      top: 230px;
      right: 165px;
    }

    #temperatura101 {
      position: absolute;
      top: 170px;
      right: 50px;
    }

    #fqiG101 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet101 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass101 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    #densidad103 {
      position: absolute;
      top: 160px; 
      left: 230px;
    }

    #densidad20103 {
      position: absolute;
      top: 340px;
      left: 210px;
    }

    #flujo103 {
      position: absolute;
      top: 160px;
      right: 290px;
    }

    #presion103 {
      position: absolute;
      top: 230px;
      right: 165px;
    }

    #temperatura103 {
      position: absolute;
      top: 170px;
      right: 50px;
    }

    #fqiG103 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet103 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass103 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    .valorItem {
      font-weight: 500;
      // color: #54545c !important;
    }
  
  }

  @media (min-width:1281px) { 
    
    #densidad101 {
    position: absolute;
    top: 160px; 
    left: 230px;
    }

    #densidad20101 {
      position: absolute;
      bottom: 160px;
      left: 210px;
    }

    #flujo101 {
      position: absolute;
      top: 160px;
      right: 290px;
    }

    #presion101 {
      position: absolute;
      top: 230px;
      right: 165px;
    }

    #temperatura101 {
      position: absolute;
      top: 170px;
      right: 50px;
    }

    #fqiG101 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet101 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass101 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    #densidad103 {
    position: absolute;
    top: 160px; 
    left: 230px;
    }

    #densidad20103 {
      position: absolute;
      top: 480;
      left: 210px;
    }

    #flujo103 {
      position: absolute;
      top: 160px;
      right: 290px;
    }

    #presion103 {
      position: absolute;
      top: 230px;
      right: 165px;
    }

    #temperatura103 {
      position: absolute;
      top: 170px;
      right: 50px;
    }

    #fqiG103 {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    #fqiNet103 {
      position: absolute;
      top: 30px;
      right: 10px;
    }

    #fqiMass103 {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    .valorItem {
      font-weight: 500;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/Muelle_TPA.vue